var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CDataTable',{staticClass:"modalTable",attrs:{"items":_vm.addresses,"fields":_vm.addressFields,"items-per-page":10,"loading":_vm.loading,"hover":"","pagination":""},scopedSlots:_vm._u([{key:"country",fn:function({item}){return [_c('td',[_vm._v(" "+_vm._s(item.country.name))])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }